import React, {useEffect, useState} from 'react';
import {Col, Row} from 'antd';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import {navigate} from 'gatsby';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {connect} from 'react-redux';

import {LazyLoadImage} from 'react-lazy-load-image-component';
import {buildImageUrl} from '~utils/helper';
import * as bannerAction from '~actions/banner';
import {BannerTypes} from '~utils/enum';
import './styles.scss';

const SaleBanner = ({getBanners, location}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [curBanners, setCurBanners] = useState([]);

  useEffect(() => {
    const getAllBanners = async () => {
      const banners = await getBanners();
      if (banners && banners.length > 0) setCurBanners(banners.filter(x => x.type === BannerTypes.Big));
    };

    Promise.all([getAllBanners()]);
  }, []);

  const onClickItem = url => {
    if (url.indexOf('//') === 0 || url.indexOf('http') === 0) {
      if (url.includes(location?.hostname)) {
        navigate(url);
        return;
      }
      window.open(url, '_blank');
      return;
    }

    const newUrl = url.includes('/') ? url : `/${url}`;

    navigate(newUrl);
  };

  const next = () => (selectedItem === curBanners.length ? setSelectedItem(0) : setSelectedItem(selectedItem + 1));

  const prev = () => (selectedItem === 0 ? setSelectedItem(curBanners.length) : setSelectedItem(selectedItem - 1));

  return (
    <Row justify='space-between' gutter={[20, 20]} className='banner-vertical'>
      <Col span={24} className='padding'>
        <div className='big-banner'>
          <div className='prev' onClick={prev}>
            <span className='prev-icon'>
              <LeftOutlined />
            </span>
          </div>
          <Carousel
            autoPlay
            infiniteLoop
            showThumbs={false}
            showArrows={false}
            selectedItem={selectedItem}
            showStatus={false}
          >
            {curBanners.map(x => (
              <div className='banner-item' key={`banner-${x.id}`} title={x.caption} onClick={() => onClickItem(x.url)}>
                <LazyLoadImage
                  className='banner-image'
                  src={buildImageUrl(x.imageUrl, '948x360')}
                  alt={x.name}
                  width={948}
                  height={360}
                />
                {/* <div className='banner-item-caption'>{x.caption}</div> */}
              </div>
            ))}
          </Carousel>
          <div className='next' onClick={next}>
            <span className='next-icon'>
              <RightOutlined />
            </span>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default connect(
  state => ({}),
  dispatch => ({
    getBanners: () => dispatch(bannerAction.getAllBanners()),
  })
)(SaleBanner);
